import { render, staticRenderFns } from "./adminGroupInfo.vue?vue&type=template&id=9635e080"
import script from "./adminGroupInfo.vue?vue&type=script&lang=js"
export * from "./adminGroupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports